import React, { useState } from "react";
import {
  Box,
  Image,
  Text,
  Heading,
  Badge,
  IconButton,
  HStack,
  Button,
} from "@chakra-ui/react";
import { StarIcon } from "@chakra-ui/icons";
import { FaHeart, FaPen } from "react-icons/fa";
import Translate from "../../LanguageTranslation/Translate";
import ExternalLinkButton from "../../ExternalLinkButton";
import DefaultImage from "../../../assets/images/bucketlist_icons/Explore.png";

const ActivityCard = ({ activity, manual, handleDelete, handleEdit }) => {
  // console.log("activity", activity);

  // Function to handle box click and open link
  const handleBoxClick = () => {
    const url = activity.productUrl || activity.webURL;
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      cursor="pointer"
      onClick={handleBoxClick}
    >
      <Box position="relative">
        <Image
          src={activity?.images?.[0]?.variants?.[3]?.url || DefaultImage}
          fallbackSrc={DefaultImage}
          alt={activity?.title || "Activity"}
          width="100%"
          height="30vh"
        />
        <IconButton
          aria-label="Add to favorites"
          icon={<FaHeart />} // Conditional icon rendering
          size="md"
          bg="none"
          _hover={{ bg: "none" }}
          position="absolute"
          top="3px"
          right="3px"
          borderRadius="full"
          color="red.500"
          onClick={handleDelete}
        />
      </Box>
      <Box p="6">
        <HStack mb={3}>
          <Heading display="flex" size="sm" mb="0" noOfLines={1}>
            <Translate text={activity.title || "Untitled Activity"} />
          </Heading>
          {manual === "manual" && (
            <IconButton
              aria-label="Edit activity"
              icon={<FaPen />}
              size="sm"
              bg="none"
              _hover={{ bg: "gray.100" }}
              ml={2}
              onClick={(e) => {
                e.stopPropagation();
                handleEdit(activity);
              }}
            />
          )}
        </HStack>
        {/* <Text fontSize="sm" color="gray.500" mb={2}>
          {activity.primaryDestinationName}, {activity.attractionCity}
        </Text> */}
        <Box d="flex" alignItems="baseline">
          <HStack spacing={2} mb={2}>
            <StarIcon boxSize={3} color="#3A4135" mb={0} />
            <Text mb={0} fontSize="sm">
              {activity?.reviews?.combinedAverageRating
                ? activity.reviews.combinedAverageRating.toFixed(2)
                : "N/A"}
            </Text>
          </HStack>
          {/* Book Button */}
          {(activity.productUrl || activity.webURL) && (
            <ExternalLinkButton
              as="a"
              href={activity.productUrl || activity.webURL}
              rel="noopener noreferrer"
              size="sm"
              bg="#286328"
              _hover="none"
              _active="none"
              textColor="white"
              width="full"
              mt={2}
            >
              <Translate text="Book" />
            </ExternalLinkButton>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ActivityCard;
